<template>
    <date-picker :name="dpname" v-model="dpdate" :config="options" @dp-change="changeValue"></date-picker>
</template>

<script>
//import 'bootstrap/dist/css/bootstrap.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  name: "mmf-datetimepicker",
  components: {
      datePicker
  },
  props: {
      "name": {
          type: String
      },
      "date": {
          type: Object,
          default: function() {
              return null
          }
      },
      'value': {
          type: String
      }
  },
  data: function() {
    return {
        dpdateFormatted : this.date != null ? this.date.format(this.$t('datetime.format.sendMode')) : "" ,
        dpname: this.name,
        dpdate: this.date,
        options: {
            // https://momentjs.com/docs/#/displaying/
            format: this.$t('datetime.format.viewMode'),
            useCurrent: false,
            showClear: true,
            showClose: true,
            icons: {
                time: 'fa fa-clock',
                date: 'fa fa-calendar',
                up: 'fa fa-arrow-up',
                down: 'fa fa-arrow-down',
                previous: 'fa fa-chevron-left',
                next: 'fa fa-chevron-right',
                today: 'fa fa-calendar-check',
                clear: 'fa fa-trash-alt',
                close: 'fa fa-times-circle'
            }
        }
    }
  },
    methods: {
        changeValue: function ($event) {
            var moment = $event.date;
            if (moment) {
                this.dpdate = moment.toDate()
                this.dpdateFormatted = moment.format(this.$t('datetime.format.sendMode'))
            }
            else {
                this.dpdate = null
                this.dpdateFormatted = "";
            }
            this.$emit('input', this.dpdateFormatted);
        }
    },
    mounted(){
        if(this.value=="")this.$emit('input', this.dpdateFormatted);
        else{
            var str = this.value;
            this.dpdate=new Date(str)
            }
    },
      watch: {
      value:function(val){
          if(val == "")
           this.dpdate=null;
      }
  },
}
</script>